var PropertyDefinition = /** @class */ (function () {
    function PropertyDefinition() {
        this.array = false;
        this.set = false;
        this.readonly = false;
        this.writeonly = false;
    }
    return PropertyDefinition;
}());
export { PropertyDefinition };
